<div class="container flex flex-column align-content-center align-items-center error-box">
  <h1 class="text-center">{{ 'ERROR' | translate }}</h1>
  <h6>{{ 'PAGE_NOT_FOUND' | translate }}</h6>
</div>
